export default theme => ({
  centerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  link: {
    textDecoration: 'none',
    cursor: 'pointer'
  },
  box: {
    marginTop: 30,
    width: '100%'
  },
  title: {
    fontSize: '1rem',
    color: '#212121',
    fontWeight: 500,
    marginTop: 10,
    marginBottom: 10
  },
  borderBottom: {
    borderBottom: '1px solid ' + theme.palette.divider
  },
  table: {
    border: '1px solid ' + theme.palette.divider,
    overflow: 'hidden',
    '& tbody > tr:last-child > td': {
      border: 'none'
    }
  },
  row: {
    backgroundColor: '#f3f3f3'
  },
  oddRow: {
    backgroundColor: theme.palette.primary.main
  },
  reviewCapabilityScoring: {
    float: 'left',
    cursor: 'pointer'
  },
  buyMessage: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 5,
    border: '0.5px solid ' + theme.palette.grey['300'],
    justifyContent: 'center',
    padding: '3rem',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  tableText: {
    fontSize: '0.7rem'
  },
  tableHeader: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    fontWeight: 'bold'
  },
  disabled: {
    color: theme.palette.grey['500']
  }
});
